import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { APIKeyApi } from '@/type';
import { apiOf } from '@/util';

export const create = apiOf<
  APIKeyApi.Create.Request,
  APIKeyApi.Create.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/annotation/management',
  }),
);

export const decryptAPIKey = apiOf<
  APIKeyApi.DecryptAPIKey.Request,
  APIKeyApi.DecryptAPIKey.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/annotation/management/:id/key',
  }),
);

export const generateAPIKey = apiOf<
  APIKeyApi.GenerateAPIKey.Request,
  APIKeyApi.GenerateAPIKey.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/annotation/management/key',
  }),
);

export const get = apiOf<APIKeyApi.Get.Request, APIKeyApi.Get.Response>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/annotation/management/:id',
  }),
);

export const getCount = apiOf<
  APIKeyApi.GetCount.Request,
  APIKeyApi.GetCount.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/annotation/management/count',
  }),
);

export const getList = apiOf<
  APIKeyApi.GetList.Request,
  APIKeyApi.GetList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/annotation/management',
  }),
);
export const remove = apiOf<
  APIKeyApi.Remove.Request,
  APIKeyApi.Remove.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/annotation/management/:id',
  }),
);

export const update = apiOf<
  APIKeyApi.Update.Request,
  APIKeyApi.Update.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/annotation/management/:id',
  }),
);
